/**
 * The Edition 001 live view's inspection arc, shared by the DOM stage that
 * reads pointer/keyboard input and the R3F scene that solves the camera frame.
 *
 * It lives outside both so the stage can bound a drag without importing three
 * (which would pull the whole renderer into the page's first-load bundle), and
 * so the scene can fit the frame against the exact angles the visitor is able
 * to reach. The set is composed and lit from the front — the sleeve's blank
 * closed side and the bottle's unlabelled back are not the product — so turning
 * is a bounded inspection arc, never a free orbit.
 */
export const EDITION_VIEW = {
  /** Maximum turn either side of the frontal three-quarter rest pose (radians). */
  yawLimit: 0.5,
  /** Camera lift range, in normalised set units (the set is 3.2 units tall). */
  pitchMin: -0.3,
  pitchMax: 0.5,
  /** One arrow-key step. */
  keyTurn: 0.12,
  keyTilt: 0.08,
  dragYawPerPx: 0.005,
  dragPitchPerPx: 0.0028,
  /** Ambient sway amplitude, added on top of the visitor's yaw. */
  sway: 0.05,
} as const
